import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { Mic } from "@mui/icons-material";
import NodeWrapper from "./NodeWrapper";

const AudioNode = memo(({ id, data, isConnectable, selected }) => {
  const hasUrl = !!data?.url;
  const isRecorded = !!data?.record;

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<Mic />}
      title="Audio"
      color="#22c55e"
      bgColor="#F0FFF4"
      isConnectable={isConnectable}
      selected={selected}
    >
      {hasUrl ? (
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              padding: "4px 10px",
              borderRadius: 20,
              fontSize: 11,
              fontWeight: 600,
              backgroundColor: "#E8F5E9",
              color: "#2e7d32",
              border: "1px solid #22c55e30",
            }}
          >
            <Mic style={{ fontSize: 13 }} />
            Audio
          </div>
          <span
            style={{
              fontSize: 9,
              fontWeight: 700,
              padding: "2px 6px",
              borderRadius: 4,
              backgroundColor: isRecorded ? "#FFF3E0" : "#E3F2FD",
              color: isRecorded ? "#E65100" : "#1565C0",
              textTransform: "uppercase",
              letterSpacing: "0.04em",
            }}
          >
            {isRecorded ? "Gravado" : "Arquivo"}
          </span>
        </div>
      ) : (
        <div
          style={{
            fontSize: 11,
            color: "#999",
            fontStyle: "italic",
            padding: "4px 0",
          }}
        >
          Enviar audio
        </div>
      )}
    </NodeWrapper>
  );
});

AudioNode.displayName = "AudioNode";
export default AudioNode;
